import React from 'react';
import './DropdownMenu.css';
import {Icons} from "../../../constants/icons";
import {MenuItemSpec} from "./MenuItemSpec";

interface DropdownMenuProps {
	buttonProps: {
		icon: React.ReactNode;
		label: string;
		title?: string;
		className?: string;
	};
	menuItems: MenuItemSpec[];
}

interface DropdownMenuState {
	isOpen: boolean;
}

class DropdownMenu extends React.Component<DropdownMenuProps, DropdownMenuState> {
	private classBlock = 'dropdown';

	constructor(props: DropdownMenuProps) {
		super(props);
		this.state = {
			isOpen: false
		};
	}

	// Стрелочные функции для обработчиков
	private handleToggle = (): void => {
		this.setState(prevState => ({
			isOpen: !prevState.isOpen
		}));
	};

	private handleClose = (): void => {
		this.setState({ isOpen: false });
	};

	// Методы рендеринга
	private renderButton(): React.ReactNode {
		const { buttonProps } = this.props;
		const { isOpen } = this.state;
		const classBlock = this.classBlock;
		const classElement = `${classBlock}__button`;
		const classArrow = `${classBlock}__arrow`;
		const classArrowOpen = isOpen ? `${classArrow}--open` : '';

		return (
			<button
				onClick={this.handleToggle}
				className={`${classElement} ${buttonProps.className || ''}`.trim()}
				title={buttonProps.title}
			>
				<span className={`${classBlock}__icon`}>{buttonProps.icon}</span>
				<span className={`${classBlock}__label`}>
					{buttonProps.label}
				</span>
				<span className={`${classArrow} ${classArrowOpen}`.trim()}>
					{Icons.ChevronDown}
				</span>
			</button>
		);
	}

	private renderMenuItems(): React.ReactNode {
		const { menuItems } = this.props;
		const classBlock = this.classBlock;
		const classList = `${classBlock}__list`;

		return (
			<ol className={classList}>
				{menuItems.map(item => (
					<li
						key={item.id}
						className={`${classBlock}__item ${classBlock}__item--${item.id}`}
						onClick={() => {
							// Закрываем меню, если элемент - кнопка
							if (item.autoClose !== false) {
								this.handleClose();
							}
						}}
					>
						<item.render {...item}/>
					</li>
				))}
			</ol>
		);
	}

	private renderDropdown(): React.ReactNode {
		const { isOpen } = this.state;
		const classBlock = this.classBlock;
		const classOverlay = `${classBlock}__overlay`;
		const classDropdown = `${classBlock}__dropdown`;

		if (!isOpen) {
			return null;
		}

		return (
			<>
				<div className={classOverlay} onClick={this.handleClose} />
				<div className={classDropdown}>
					{this.renderMenuItems()}
				</div>
			</>
		);
	}

	render() {
		const classBlock = this.classBlock;

		return (
			<div className={classBlock}>
				{this.renderButton()}
				{this.renderDropdown()}
			</div>
		);
	}
}

export default DropdownMenu;